/* eslint-disable no-script-url */
import React from "react";
import Typography from "@material-ui/core/Typography";
import { Button } from "@material-ui/core";
import { CopyToClipboard } from "react-copy-to-clipboard";

export default function CopyText(props) {
  return (
    <>
      {props.url.length > 0 ? (
        <Button style={{ marginLeft: 0, padding: 5, minHeight: 0, minWidth: 0, textTransform: "none" }}>
          <CopyToClipboard
            text={props.url}
            onCopy={() => {
              alert("Copied to clipboard: " + props.url);
            }}
          >
            <Typography>{props.type !== "password" ? props.url : "<hidden>"}</Typography>
          </CopyToClipboard>
        </Button>
      ) : (
        "-"
      )}
    </>
  );
}
